import hd_logo from 'assets/images/hd_logo.jpg';

const Logo = () => {
	return <img src={hd_logo} width="293" height="41" border="0" alt="" />;
};

export default Logo;
